/* eslint import/prefer-default-export: 0 */

// dependencies
import moment from "moment";
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";
import { parse, addMinutes } from "date-fns";

// utils
import parseUserAgent from "Utils/userAgentParser";
import objectToQueryString from "Utils/objectToQueryString";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const GetSecurityAudits = CreateProcess({
	method: "GET",
	name: "Get Security Audits",
	type: "SECURITY:GETAUDITS",

	request: () => {
		return {
			url: `/security/audits`,
		};
	},

	success: (response) => {
		const audits = response.data.audits;

		return {
			audits,
		};
	},
});
